// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Popover } from 'antd';
import THTag from '@Atoms/THTag/THTag';

import './DisplayPermissions.scss';

interface DisplayPermissionsProps {
    profile?: string;
    permissions: string[];
    permissionsOnly?: boolean;
    noPermissionsLabel?: string;
}

const DisplayPermissions = ({
    profile = '',
    permissions = [],
    permissionsOnly,
    noPermissionsLabel = 'No permissions',
}: DisplayPermissionsProps): ReactElement => {
    const permissionsList = permissions.map((perm) => <THTag key={perm} value={perm} />);

    return permissionsOnly ? (
        <span className="display-permissions__list">
            {permissionsList}
            {permissions.length === 0 && noPermissionsLabel}
        </span>
    ) : (
        <Popover
            content={<div className="display-permissions__list">{permissionsList}</div>}
            title="Permissions"
            overlayStyle={{ width: '25rem' }}
            trigger="hover"
            placement="leftTop"
        >
            <div className="display-permissions__profile" color="black">
                {profile}
            </div>
        </Popover>
    );
};

export default DisplayPermissions;
